class Accordions extends DrupalBehavior {
  onContent(context) {
    once('accordion-initialize', '.accordion-item', context).forEach((accordion) => {
      const toggle = accordion.querySelector('.accordion-item--toggle');
      const content = accordion.querySelector('.accordion-item--content');

      if (content) {
        content.classList.add('hidden');
        content.style.height = 0;
      }

      if (toggle) {
        toggle.addEventListener('click', (e) => this.toggleAccordion(e, accordion));
      }
    });
  }

  toggleAccordion(e, accordion) {
    e.preventDefault();
    e.stopPropagation();

    const toggle = e.currentTarget;
    const title = accordion.querySelector('.accordion-item--title');
    const content = accordion.querySelector('.accordion-item--content');

    if (!title || !content) {
      return;
    }

    const isOpen = title.classList.contains('open');

    if (isOpen) {
      // Close accordion
      title.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      gsap.to(content, {
        duration: 0.4,
        ease: 'power4.out',
        height: 0,
        onComplete: function() {
          content.classList.add('hidden');
        }
      });
    } else {
      // Open accordion
      title.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      content.classList.remove('hidden');
      gsap.to(content, {
        duration: 0.4,
        ease: 'power4.out',
        height: 'auto'
      });
    }
  }
}

DrupalBehavior.register('summit_theme', 'Accordions', Accordions);